import type { WsMessage } from "@/api/websocket";
import { captureDesktopChatAuthScopeGuard } from "@/desktop/desktop-chat-auth-scope";
import type { FrameApplyContext } from "@/lib/companion-frame-reducer";
import { selectProjectByIdentity } from "@/lib/select-project-space";

let latestProjectSwitchRequest = 0;

/**
 * Denker's `switch_project`: show the user that project. Only the view
 * changes; the conversation, the input target and the draft stay as they are.
 * A newer switch, a project the user picked meanwhile or another account wins.
 */
export function applyProjectSwitchRequest(
  msg: WsMessage,
  ctx: FrameApplyContext,
): void {
  const data = msg.data as { project_id?: string; project_name?: string };
  if (!data.project_id) return;

  const requestId = ++latestProjectSwitchRequest;
  const selectedProjectId = ctx.projectStore.getState().currentProject?.id;
  const selectionRevision = ctx.projectStore.getState().selectionRevision;
  const isCurrentAuthScope = captureDesktopChatAuthScopeGuard();

  void selectProjectByIdentity(
    { projectId: data.project_id, projectName: data.project_name },
    {
      projectStore: ctx.projectStore,
      addSystemToast: ctx.addSystemToast,
      shouldContinue: () =>
        requestId === latestProjectSwitchRequest &&
        isCurrentAuthScope() &&
        ctx.projectStore.getState().selectionRevision === selectionRevision &&
        (selectedProjectId == null ||
          ctx.projectStore.getState().currentProject?.id === selectedProjectId),
    },
  );
}
